import { render, staticRenderFns } from "./_base-spinner.vue?vue&type=template&id=ade31290&scoped=true"
import script from "./_base-spinner.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-spinner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-spinner.vue?vue&type=style&index=0&id=ade31290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade31290",
  null
  
)

export default component.exports